import React, { Component } from "react";

class YETwoHighlightsProp extends Component {
  extraLine = (prop, lineNum) => {
    const { footerText2, footerText3 } = prop;
    const bannerText1 = prop.bannerText1 || "";
    const { listgenUserID } = this.props.agentData;

    if (!footerText2 && !footerText3) {
      return "";
    } else {
      return (
        <div className="extra-highlight-prop-line-container">
          {footerText2 && <p>{footerText2}</p>}
          {footerText3 && <p>{footerText3}</p>}
        </div>
      );
    }
  };
  hasExtraRepresentation = (prop) => {
    let extraRepresentationText = "";
    return extraRepresentationText;
  };
  formatStatus = (prop) => {
    const { listgenUserID } = this.props.agentData;

    const bannerText1 = prop.bannerText1 || "";

    const status = prop.status || "";
    let bannerText2 = prop.bannerText2 || "";
    if (bannerText2 && bannerText2.toLowerCase().includes("remove")) {
      bannerText2 = "";
    }

    // Determine which price to use based on status
    let price = "";
    if (status === "Sold") {
      price = prop.salePrice;
    } else if (["Active", "Pending", "Contingent"].includes(status)) {
      price = prop.listPrice;
    }
    // Format price with dollar sign and commas
    const formattedPrice = price ? `$${Number(price).toLocaleString()}` : "";
    if (status === "Active" && prop.listPrice === "0") {
      return <div>Active Listing</div>;
    }
    // Return bannerText2 with formatted price
    return (
      <div>
        {formattedPrice ? `${bannerText2} ${formattedPrice}` : bannerText2}
      </div>
    );
  };
  formatAddress = (prop) => {
    const { bannerText1 } = prop;
    return bannerText1 || "";
  };

  determineRepresentation = (prop) => {
    const { footerText1, bannerText1 = "", bannerText2 = "" } = prop;
    const { listgenUserID } = this.props.agentData;

    return footerText1 || "";
  };
  shortenCourtesy = (brokerage, isSellingAgent, isBuyingAgent, prop) => {
    const { courtesyText1, checkedBuyerRepresented } = prop;
    const { listgenUserID } = this.props.agentData;

    if (listgenUserID === "104835" || listgenUserID === "100462") {
      return "";
    } else if (
      checkedBuyerRepresented === true ||
      (isBuyingAgent === true && !isSellingAgent)
    ) {
      if (courtesyText1 && courtesyText1.length >= 50) {
        return `${courtesyText1.slice(0, 50)}...`;
      }
      return courtesyText1;
    }
    return "";
  };
  photoURLToUse = (prop) => {
    let url;
    if (prop.optimizedPhotoURL === "ERROR") {
      url = prop.photoURL;
    } else if (prop.optimizedPhotoURL) {
      url = prop.optimizedPhotoURL;
    } else {
      url = prop.photoURL;
    }
    return url;
  };

  renderHighlightFooter = (prop, useAlt, has3Footers) => {
    const { determineRepresentation, shortenCourtesy, extraLine } = this;
    const { listgenUserID } = this.props.agentData;
    if (listgenUserID === "x101001") {
      return "";
    }
    if (listgenUserID === "x102843") {
      has3Footers = false;
    }
    const courtesyLine = shortenCourtesy(
      prop.brokerageName,
      prop.isSellingAgent,
      prop.isBuyingAgent,
      prop,
    );
    const className = `highlight-footer-group${
      has3Footers ? " three-footer-container" : ""
    }`;
    let specialtextStyles = "";

    if (
      has3Footers &&
      courtesyLine &&
      extraLine(prop) &&
      listgenUserID === "107348"
    ) {
      return (
        <div
          className={`${className} three-lines-prop flipped-three-lines ${specialtextStyles}`}
        >
          <div>{determineRepresentation(prop)}</div>

          {prop.footerText2 && extraLine(prop)}
          {courtesyLine && (
            <div className="brokerage-courtesy smaller-courtesy">
              {courtesyLine}
            </div>
          )}
        </div>
      );
    } else if (has3Footers && courtesyLine && extraLine(prop)) {
      return (
        <div className={`${className} three-lines-prop ${specialtextStyles}`}>
          <div>{determineRepresentation(prop)}</div>
          {courtesyLine && (
            <div className="brokerage-courtesy">{courtesyLine}</div>
          )}
          {prop.footerText2 && extraLine(prop)}
        </div>
      );
    } else {
      return (
        <div className={`${className} ${specialtextStyles}`}>
          <div>{determineRepresentation(prop)}</div>
          {courtesyLine && (
            <div className="brokerage-courtesy">{courtesyLine}</div>
          )}
          {prop.footerText2 && (
            <div className="brokerage-courtesy">{extraLine(prop)}</div>
          )}
        </div>
      );
    }
  };

  render() {
    let {
      agentData,
      prop,
      useAlt,
      use1Prop,
      use1Prop3Photos,
      altBanner,
      showBanner,
      use2Props,
      has3Footers,
    } = this.props;
    prop = prop || {};

    const { listgenUserID } = agentData;
    const {
      photoURLToUse,
      formatAddress,
      formatStatus,
      hasExtraRepresentation,
      renderHighlightFooter,
    } = this;

    let isGalliTeam = listgenUserID === "x102843";
    let isSophieTsang = listgenUserID === "102567";
    let specialImagePosition = "";
    let photoFooterStyles;
    let bannerTextStyles;
    if (listgenUserID === "102567") {
      bannerTextStyles = "banner-text-show-none";
    }
    if (use2Props) {
      specialImagePosition = "highlight-img-contain";
    }

    let useComingSoonBanner = false;
    // if (

    //   (listgenUserID === "106531" &&
    //     prop.bannerText1.includes("Easton Addition"))
    // ) {
    //   useComingSoonBanner = true;
    // }

    if (use1Prop) {
      return (
        <div>
          <div className={`one-prop-banner-row ${bannerTextStyles}`}>
            <div className="one-prop-row-banner-text">
              <div style={{ textTransform: "capitalize" }}>
                {formatAddress(prop)}
              </div>
              {formatStatus(prop)}
            </div>
            <div
              className={`one-prop-photo-footer-text ${useAlt && "white-text"}`}
            >
              {renderHighlightFooter(prop, useAlt, has3Footers)}
            </div>
          </div>
          <img
            src={photoURLToUse(prop)}
            className={`property-highlight-photo-0 ${specialImagePosition}`}
            alt={prop.bannerText1}
          />
        </div>
      );
    } else if (use1Prop3Photos && !showBanner && altBanner) {
      return (
        <img
          src={photoURLToUse(prop)}
          className={`property-highlight-photo-0 ${specialImagePosition}`}
          alt={prop.bannerText1}
        />
      );
    } else if (use1Prop3Photos && showBanner && altBanner) {
      return (
        <>
          <div className="row-banner-text lowered-banner">
            <div
              className={`photo-footer-text ${
                altBanner && "no-mt-banner-text"
              }`}
            >
              {renderHighlightFooter(prop, useAlt, has3Footers)}
            </div>
          </div>
          <img
            src={photoURLToUse(prop)}
            className={`property-highlight-photo-0 ${specialImagePosition}`}
            alt={prop.bannerText1}
          />
        </>
      );
    } else if (use1Prop3Photos) {
      return (
        <>
          <div className="row-banner-text lowered-banner">
            <div>{formatAddress(prop)}</div>
            {formatStatus(prop)}
          </div>
          <img
            src={photoURLToUse(prop)}
            className={`property-highlight-photo-0 ${specialImagePosition}`}
            alt={prop.bannerText1}
          />
        </>
      );
    } else if (use2Props) {
      if (isGalliTeam) {
        specialImagePosition = "reduced-image-height";
      } else if (isSophieTsang) {
        specialImagePosition = "extra-reduced-image-height";
      }
      return (
        <>
          <div
            className={`row-banner-text ${
              hasExtraRepresentation(prop) && "extra-representation-banner-text"
            } ${bannerTextStyles}`}
          >
            <div>{formatAddress(prop)}</div>
            {formatStatus(prop)}
          </div>
          <img
            src={photoURLToUse(prop)}
            className={`property-highlight-photo-0 ${specialImagePosition}`}
            alt={prop.bannerText1}
          />
          <div
            className={`photo-footer-text ${
              useAlt && "white-text"
            } ${photoFooterStyles}`}
          >
            {renderHighlightFooter(prop, useAlt, has3Footers)}
          </div>
        </>
      );
    } else {
      if (isGalliTeam) {
        specialImagePosition = "reduced-image-height";
      } else if (isSophieTsang) {
        specialImagePosition = "extra-reduced-image-height";
      }
      return (
        <>
          <div
            className={`row-banner-text ${
              hasExtraRepresentation(prop) && "extra-representation-banner-text"
            } ${bannerTextStyles}`}
          >
            <div>{formatAddress(prop)}</div>
            {formatStatus(prop)}
          </div>

          {useComingSoonBanner ? (
            <div className="property-highlight-photo-container">
              <img
                src={photoURLToUse(prop)}
                className={`property-highlight-photo-0 ${specialImagePosition}`}
                alt={prop.bannerText1}
              />
              {useComingSoonBanner && (
                <div className="coming-soon-banner">
                  <span>Coming</span>
                  <span>Soon</span>
                </div>
              )}
            </div>
          ) : (
            <img
              src={photoURLToUse(prop)}
              className={`property-highlight-photo-0 ${specialImagePosition}`}
              alt={prop.bannerText1}
            />
          )}

          <div
            className={`photo-footer-text ${
              useAlt && "white-text"
            } ${photoFooterStyles}`}
          >
            {renderHighlightFooter(prop, useAlt, has3Footers)}
          </div>
        </>
      );
    }
  }
}

export default YETwoHighlightsProp;
